var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluiddesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: "100%",
    height: "100%",
    viewBox: "20 290 750 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.442,621.314 H 143.76 V 514.505 H 34.442 Z",
    transform: "matrix(4.6835774,0,0,4.7936111,-417.70484,-2851.4604)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.442,621.314 H 143.76 V 514.505 H 34.442 Z",
    transform: "matrix(4.6835774,0,0,4.7936111,-340.25253,-2653.7143)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.442,621.314 H 143.76 V 514.505 H 34.442 Z",
    transform: "matrix(4.6835774,0,0,4.7936111,-512.39273,-2593.2142)",
    id: "path14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    "aria-label": "  ",
    transform: "matrix(0,0,0,0,310.44267,343.05333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "",
    style: {
      fill: "#000000",
      fillOpacity: 0.6,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "",
    style: {
      fill: "#000000",
      fillOpacity: 0.6,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 19.663758,-18.352203 h 11.484375 c 3.703125,0 5.542969,0.597656 7.265625,1.125 v -9.234375 c -1.722656,0.527344 -3.5625,1.113281 -7.265625,1.113281 H 19.663758 v -9.890625 h 13.136719 c 3.761718,0 5.613281,0.585938 7.265625,1.113281 l -1.253907,-8.109375 H 2.2379766 c 0.796875,1.640625 1.3242187,3.222657 1.3242187,7.253907 v 27.7148434 c 0,4.03125 -0.5273437,5.6132812 -1.3242187,7.265624975 H 20.987977 C 20.191102,-1.6529844 19.663758,-3.2350156 19.663758,-7.2662656 Z m 24.46875,11.2265624 c 0,4.2890625 -0.796875,5.5429687 -1.722656,7.124999975 H 61.417664 C 60.491883,-1.5826719 59.706727,-2.8365781 59.706727,-7.1256406 V -42.235016 H 42.409852 c 0.925781,1.582032 1.722656,2.835938 1.722656,7.125 z M 110.09149,-6.40625e-4 C 109.16571,-1.5826719 108.36884,-2.8365781 108.36884,-7.1256406 V -31.020172 H 91.08368 c 0.914062,1.582031 1.710937,2.835938 1.710937,7.125 v 15.2460939 c 0,1.921875 -0.65625,2.578125 -2.578125,2.578125 h -5.671875 c -1.910156,0 -2.578125,-0.65625 -2.578125,-2.578125 V -31.020172 H 64.681336 c 0.925781,1.582031 1.710937,2.835938 1.710937,7.125 v 12.609375 c 0,6.9257814 3.035157,11.285156375 10.359375,11.285156375 h 12.609375 c 2.308594,0 3.304688,-1.652343775 4.03125,-3.234374975 h 0.128907 l 0.457031,3.234374975 z m 4.9541,-7.124999975 c 0,4.2890625 -0.79687,5.5429687 -1.72265,7.124999975 h 19.00781 C 131.40497,-1.5826719 130.61981,-2.8365781 130.61981,-7.1256406 V -31.020172 h -17.29687 c 0.92578,1.582031 1.72265,2.835938 1.72265,7.125 z m 0.12891,-35.1093754 v 8.179688 h 15.31641 v -8.179688 z m 47.53711,33.7851566 c 0,1.7226563 -0.65625,2.3789063 -2.16797,2.3789063 h -6.21094 c -1.51172,0 -2.17968,-0.65625 -2.17968,-2.3789063 V -22.570953 c 0,-1.722656 0.66796,-2.378906 2.17968,-2.378906 h 6.21094 c 1.51172,0 2.16797,0.65625 2.16797,2.378906 z m 16.89844,8.449218775 C 178.88348,-1.2545469 178.29755,-2.6373594 178.29755,-5.8131406 V -42.235016 h -16.89844 c 0.72656,1.253907 1.3125,2.636719 1.3125,5.800782 v 8.449218 h -0.12891 c -0.39843,-1.253906 -1.18359,-3.035156 -4.01953,-3.035156 h -12.21094 c -7.125,0 -9.77343,3.960938 -9.77343,9.632813 v 11.7539059 c 0,5.671875 2.64843,9.632812475 9.77343,9.632812475 h 13.13672 c 1.78125,0 2.56641,-1.054687475 3.69141,-3.304687475 l 0.85547,3.304687475 z m 0,0",
    style: {
      fill: "#747775",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    "aria-label": "Fluid",
    transform: "matrix(1.3333333,0,0,1.3333333,199.684,393.25867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "",
    style: {
      fill: "#000000",
      fillOpacity: 0.6,
      fillRule: "nonzero",
      stroke: "none"
    },
    "aria-label": " ",
    transform: "matrix(0,0,0,0,449.32,388.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "",
    style: {
      fill: "#000000",
      fillOpacity: 0.6,
      fillRule: "nonzero",
      stroke: "none"
    },
    "aria-label": " ",
    transform: "matrix(1.3333333,0,0,1.3333333,449.32,388.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 19.665313,-35.238922 h 8.390625 c 2.636718,0 3.035156,0.585938 3.035156,3.421875 v 21.386719 c 0,2.8359374 -0.398438,3.4335936 -3.035156,3.4335936 H 19.665313 Z M 3.56375,-7.2662656 c 0,4.03125 -0.5273437,5.6132812 -1.3242187,7.265624975 H 35.052031 c 8.976563,0 12.140625,-3.433593775 12.140625,-12.011718375 v -18.210938 c 0,-8.589844 -3.164062,-12.011719 -12.140625,-12.011719 H 2.2395313 c 0.796875,1.640625 1.3242187,3.222657 1.3242187,7.253907 z M 67.791289,-18.211578 v -4.230469 c 0,-1.78125 0.527344,-2.507812 2.25,-2.507812 h 6.398438 c 1.722656,0 2.25,0.726562 2.25,2.507812 v 4.230469 z m 26.074219,6.070312 v -9.503906 c 0,-6.46875 -1.980469,-9.375 -8.976563,-9.375 H 61.193633 c -6.996094,0 -8.976563,2.90625 -8.976563,9.375 v 12.2695314 c 0,6.46875 1.980469,9.374999975 8.976563,9.374999975 H 92.213164 L 93.408477,-7.3951719 c -2.507813,1.125 -4.101563,1.3242188 -7.066407,1.3242188 H 71.365508 c -2.519531,0 -3.503906,-0.9257813 -3.574219,-3.1640625 v -2.9062504 z m 22.163082,-9.644531 c -1.52343,0 -2.10937,-0.386719 -2.10937,-1.113281 v -1.324219 c 0,-0.726562 0.58594,-1.125 2.10937,-1.125 h 12.07032 c 3.63281,0 7.99218,0.527344 9.24609,2.050781 l -1.32422,-7.722656 h -26.78906 c -5.94141,0 -9.832032,3.164063 -9.832032,7.921875 v 6 c 0.1875,3.832031 1.312502,7.4648439 8.437502,7.4648439 h 13.53515 c 1.58204,0 2.05079,0.3984375 2.05079,1.6523437 v 0.65625 c 0,1.2539063 -0.46875,1.6523438 -2.05079,1.6523438 h -13.13671 c -5.47266,0 -6.85547,-0.46875 -9.70313,-1.78125 l 1.195313,7.453124975 h 28.910157 c 6.92578,0 9.30469,-4.218749975 9.30469,-8.179687475 v -6.2109379 c -0.19922,-3.761718 -1.32422,-7.394531 -8.44922,-7.394531 z m 45.71485,7.335938 7.18359,14.449218375 h 18.82031 C 185.42703,-2.7076719 185.23953,-3.1061094 183.31766,-6.3404844 l -10.16016,-17.4257816 6.79688,-5.273437 c 1.125,-0.855469 2.57812,-1.382813 3.96093,-1.851563 v -0.128906 h -14.0625 c -0.32812,1.511719 -0.65625,2.707031 -3.29297,4.886719 l -7.46484,6 v -22.101563 h -17.28516 c 0.92579,1.582032 1.71094,2.835938 1.71094,7.125 v 27.9843754 c 0,4.2890625 -0.78515,5.5429687 -1.71094,7.124999975 h 19.00782 C 159.89188,-1.5826719 159.095,-2.8365781 159.095,-7.1256406 v -5.2148434 z m 0,0",
    style: {
      fill: "#2852a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    "aria-label": "Desk",
    transform: "matrix(1.3333333,0,0,1.3333333,469.87333,393.25867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    "aria-label": "   ",
    transform: "matrix(0,0,0,0,393.63733,423.75467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 0,0 76.66,-75.82 c 11.16,-11.04 29.15,-10.94 40.19,0.23 L 214.07,22.69 173.15,63.16 96.96,-13.88 20.29,61.95 C 9.14,72.99 -8.85,72.89 -19.89,61.73 l -97.22,-98.3 40.92,-40.47 z",
    style: {
      fill: "#2852a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.28468267,0,0,-0.278148,118.91333,329.392)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 0,0 76.66,75.82 76.2,-77.03 40.91,40.47 -97.22,98.29 c -11.04,11.16 -29.03,11.26 -40.18,0.22 l -76.66,-75.82 -76.2,77.04 -40.92,-40.47 97.22,-98.3 C -29.15,-10.94 -11.16,-11.04 0,0",
    style: {
      fill: "#2852a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.28468267,0,0,-0.278148,96.864,384.39467)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 0,0 -76.66,75.82 c -11.16,11.04 -29.15,10.94 -40.19,-0.23 l -97.22,-98.28 40.92,-40.47 76.19,77.04 76.67,-75.83 c 11.15,-11.04 29.14,-10.94 40.18,0.22 l 97.22,98.3 -40.92,40.47 z",
    style: {
      fill: "#2852a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.28468267,0,0,-0.278148,145.86933,401.22267)",
    clipPath: "url(#clipPath14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluiddesk);
export default __webpack_public_path__ + "static/media/fluiddesk.0ee872673ee5cacec1a9e5572dd69310.svg";
export { ForwardRef as ReactComponent };